import { render } from "./statisticalData.vue?vue&type=template&id=4814ac53"
import script from "./statisticalData.vue?vue&type=script&lang=js"
export * from "./statisticalData.vue?vue&type=script&lang=js"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__